import { Ref } from "react";

import { DDQForm, FormConfig } from "../types";
import FormSection, { Mode } from "./FormSection";

export type Props = {
  register?: () => Ref<any>;
  mode: Mode;
  form: DDQForm;
};

export default function TravelRuleImplFormSection({ register, mode, form }: Props) {
  const formConfig: FormConfig = {
    sharingTravelRuleInfo: {
      type: "text",
      label: "8A. Which technical solution(s) does the Entity support for sharing Travel Rule information?",
    },
    technicalDetailsRequired: {
      type: "text",
      label:
        "8B. Please provide the technical details (IDs, endpoints, URLs, etc.) required to send Travel Rule information to the Entity for each solution the Entity supports",
    },
    contactInfo: {
      type: "text",
      label: "8C. Name, email and phone number of travel rule contact",
    },
  };

  return (
    <FormSection
      title="Section 8. Travel Rule Implementation"
      formConfig={formConfig}
      register={register}
      mode={mode}
      form={form}
    />
  );
}
